import React from 'react';

export const SectionHeader = ({ title, description }) => (
  <div className="mb-4">
    <h3 className="text-lg font-semibold text-gray-900 mb-1">{title}</h3>
    <p className="text-sm text-gray-600">{description}</p>
  </div>
);